import { SlotsActionTypes } from '../actions';

const initState = {
    message: null,
    loading: false,
    slotsGames: null,
    categories: null,
    config: null,
    currentGame: '',
    gameSymbols: [],
    loadingBalance: false,
    messageBalance: null,
    balances: [],
    iframeUrl: null,
    partner: null,
    gameTypeId: null,
    platformGameName: null
}

const slots = (state = initState, action) => {
    switch (action.type) {
        case SlotsActionTypes.Get_Slots_Games_Request:
            return {
                ...state,
                loading: true,
                message: null,
                slotsGames:null,
                currentGame: null,
                gameSymbols: [],
                iframeUrl: null,
                partner: null,
                gameTypeId: null,
                platformGameName: null
            }
        case SlotsActionTypes.Get_Slots_Games_Success:
            return {
                ...state,
                loading: false,
                slotsGames: action.slotsGames,
                categories: action.categories,
                config: action.config,
                message: null,
                slotsFrontPageTemplates: action.slotsFrontPageTemplates,
                slotsGamesCategories: action.slotsGamesCategories,
            }
        case SlotsActionTypes.Get_Slots_Games_Error:
            return {
                ...state,
                loading: false,
                message: action.message,
                slotsGames:null
            }

        case SlotsActionTypes.Slots_Game_Connect_Request:
            return {
                ...state,
                token:null,
                message: null,

            }
        case SlotsActionTypes.Slots_Game_Connect_Success:
            return {
                ...state,
                token: action.token,
                message: null,
                currentGame: action.currentGame,
                gameSymbols: action.gameSymbols,
                iframeUrl: action.iframeUrl,
                partner: action.partner,
                gameTypeId: action.gameTypeId,
                platformGameName: action.platformGameName
            }
        case SlotsActionTypes.Slots_Game_Connect_Error:
            return {
                ...state,
                message: action.message,
            }


        case SlotsActionTypes.Get_Slots_Bonus_Games_By_Condition_Id_Request:
            return {
                ...state,
                loadingSlotInfo: true

            }
        case SlotsActionTypes.Get_Slots_Bonus_Games_By_Condition_Id_Success:
            return {
                ...state,
                loadingSlotInfo: false,
                slotBonusGame: action.slotBonusGame,
                slotBonusGameError: undefined
            }
        case SlotsActionTypes.Get_Slots_Bonus_Games_By_Condition_Id_Error:
            return {
                ...state,
                loadingSlotInfo: false,
                slotBonusGame: undefined,
                slotBonusGameError: action.slotBonusGameError
            }



        case SlotsActionTypes.Slots_Game_Init:
            return {
                ...state,
                token:null,
                currentGame: null,
                gameSymbols: [],
                iframeUrl: null,
                partner: null,
                gameTypeId: null,
                platformGameName: null

            }
        case SlotsActionTypes.Current_Slots_Game:
        return {
            ...state,
            currentGame: action.currentGame,
        }
        case SlotsActionTypes.Set_Slots_Round_Finish:
            return {
                ...state,
                roundFinished: action.roundFinished,
                gameId: action.gameId,
                gameName: action.gameName,
            }
        case SlotsActionTypes.Set_Slots_Bonus_Games:
            return {
                ...state,
                slotsBonusGamesCategories: action.slotsBonusGamesCategories,
                slotsBonusGames: action.slotsBonusGames,
            }
     
        default:
            return state
    }
}
export default slots;